(function (Translator) {
    // en
    Translator.add("administration.user_search_button", "Search", "EvpAdministrationBundle", "en");
    Translator.add("administration.user_search_label", "User ID", "EvpAdministrationBundle", "en");
    Translator.add("forbidden", "Not permitted", "EvpAdministrationBundle", "en");
    Translator.add("internal_server_error", "Server error", "EvpAdministrationBundle", "en");
    Translator.add("invalid_code", "Invalid code", "EvpAdministrationBundle", "en");
    Translator.add("invalid_grant", "Access denied", "EvpAdministrationBundle", "en");
    Translator.add("invalid_parameters", "Invalid parameters", "EvpAdministrationBundle", "en");
    Translator.add("invalid_request", "Incorrect request", "EvpAdministrationBundle", "en");
    Translator.add("invalid_state", "Invalid status", "EvpAdministrationBundle", "en");
    Translator.add("limits_exceeded", "Limit reached", "EvpAdministrationBundle", "en");
    Translator.add("logout", "Log out", "EvpAdministrationBundle", "en");
    Translator.add("not_acceptable", "Not accepted", "EvpAdministrationBundle", "en");
    Translator.add("not_found", "Not found", "EvpAdministrationBundle", "en");
    Translator.add("pagination.first", "First", "EvpAdministrationBundle", "en");
    Translator.add("pagination.last", "Last", "EvpAdministrationBundle", "en");
    Translator.add("pagination.next", "Next", "EvpAdministrationBundle", "en");
    Translator.add("pagination.page_out_of", "form", "EvpAdministrationBundle", "en");
    Translator.add("pagination.previous", "Back", "EvpAdministrationBundle", "en");
    Translator.add("rate_limit_exceeded", "Limit reached", "EvpAdministrationBundle", "en");
    Translator.add("unauthorized", "Access denied", "EvpAdministrationBundle", "en");
})(Translator);
